import dayjs from 'dayjs'
import { projectTypeName } from '../../../common/constants'
import { Division } from '../../../domain/divisions/division'
import { centsToDollarsDisplay } from '../../displayFormatters'
import { CsvColumn, TableSort } from '../reportCsvExport'
import { flattenStatusBuckets, StatusBucket, WithStatus } from '../statusBucketsExport'
import { EstimateReportData, EstimatesSummary } from './estimatesReportApi'

export type EstimateExportRow = WithStatus<EstimateReportData>

export const estimateStatusBuckets: StatusBucket[] = [
  { key: 'unsent', label: 'Draft' },
  { key: 'sent', label: 'Sent' },
  { key: 'approved', label: 'Approved' },
  { key: 'lost', label: 'Lost' },
]

export const compareEstimatesByCreatedDate = (a: EstimateReportData, b: EstimateReportData): number =>
  dayjs(a.estimateDateUtc).unix() - dayjs(b.estimateDateUtc).unix()

// The estimates table opens sorted newest first, so an export before any click matches it.
export const defaultEstimatesTableSort: TableSort<EstimateReportData> = { compare: compareEstimatesByCreatedDate, order: 'descend' }

export const getEstimateExportRows = (estimates: EstimatesSummary): EstimateExportRow[] =>
  flattenStatusBuckets<EstimateReportData>(estimates, estimateStatusBuckets)

export const getEstimateDivisionNames = (divisionIds: string, divisions: Division[]): string =>
  divisionIds ? divisionIds.split('|').map(id => divisions.find(d => String(d.id) === id)?.name || id).join(', ') : ''

export const estimateExportColumns = (divisions: Division[]): CsvColumn<EstimateExportRow>[] => [
  { title: 'Created Date', dataIndex: 'estimateDateUtc', render: (_, record) => dayjs(record.estimateDateUtc).format('MM/DD/YYYY') },
  { title: 'Job Number', dataIndex: 'jobNo' },
  { title: 'Name', dataIndex: 'jobName' },
  { title: 'Customer', dataIndex: 'displayName' },
  { title: 'Property', render: (_, record) => `${record.address1}, ${record.city}, ${record.state}, ${record.zip}` },
  { title: 'Final Price', dataIndex: 'price', render: (_, record) => centsToDollarsDisplay(record.price), exportCents: record => record.price },
  { title: 'Job Type', dataIndex: 'jobType', render: (_, record) => projectTypeName(record.jobType) },
  { title: 'Sales Person', dataIndex: 'salesPersonName' },
  { title: 'Division', dataIndex: 'divisions', render: (_, record) => getEstimateDivisionNames(record.divisions, divisions) },
  { title: 'Status', dataIndex: 'status' },
]
